import { useNavigate } from "react-router-dom";
import { AUDIENCE, setAudience } from "../audience";
import { brandTagline } from "../content/shared";

export default function DecisionPage() {
  const navigate = useNavigate();

  function choose(audience) {
    setAudience(audience);
    navigate(audience === AUDIENCE.EMPLOYER ? "/for-employers" : "/for-seekers");
  }

  return (
    <section className="mkt-decision">
      <div className="mkt-decision__brand">
        <h1 className="mkt-brand">CareerMaster</h1>
        <p className="mkt-decision__tagline">{brandTagline}</p>
      </div>
      <p className="mkt-decision__prompt">I am a…</p>
      <div className="mkt-decision__choices">
        <button
          type="button"
          className="mkt-choice"
          onClick={() => choose(AUDIENCE.SEEKER)}
        >
          <span className="mkt-choice__label">Job seeker</span>
          <span className="mkt-choice__hint">
            Build a verified profile. Get matched when you are ready.
          </span>
        </button>
        <button
          type="button"
          className="mkt-choice"
          onClick={() => choose(AUDIENCE.EMPLOYER)}
        >
          <span className="mkt-choice__label">Employer</span>
          <span className="mkt-choice__hint">
            Post roles and soft jobs. Review ranked matches.
          </span>
        </button>
      </div>
    </section>
  );
}
